import { useState } from "react";
import "../../Styling/Contact/Contact.css";
import useDocumentTitle from "../../Utilities/useDocumentTitle";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import logo from "../../Assets/Images/favicon.png";
import { CircularProgress } from "@mui/material";
import { Helmet } from "react-helmet";

// Automation
import { contactData } from "../../Data/ContactData";

const Contact = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const isDisabled =
    firstName.length === 0 ||
    lastName.length === 0 ||
    email.length === 0 ||
    message.length === 0;

  useDocumentTitle("42nd - Contact Us");

  return (
    <main className="contact-wrapper">
      <Helmet>
        <meta charSet="utf-8" />
        <title>42nd - Contact Us</title>
        <meta
          name="description"
          content="Contact · Ask 42nd Apps A Question · Email: info@42nd.app"
        />
      </Helmet>
      <main className="container">
        <div className="flex">
          <section className="form-section">
            <div className="form-wrapper">
              <img className="image-logo" src={logo} alt="" />
              <div>
                <h2 className="contact-title">Contact Us</h2>
                <p className="contact-subtitle">
                  Let's create some magic together
                </p>
              </div>
              <div className="form-container">
                {success && (
                  <Alert
                    icon={<CheckIcon fontSize="inherit" />}
                    severity="success"
                  >
                    {success}
                  </Alert>
                )}
                {error && <Alert severity="error">{"error"}.</Alert>}
                {/* Name */}
                <div className="form-name-wrapper">
                  <input
                    type="text"
                    id="fname"
                    name="fname"
                    placeholder="First name"
                    className="form-name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                  <input
                    type="text"
                    id="lname"
                    name="lname"
                    placeholder="Last name"
                    className="form-name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
                {/* Email */}
                <input
                  type="text"
                  id="email"
                  name="email"
                  placeholder="Email Address"
                  className="form-email-address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {/* Message */}
                <textarea
                  type="text"
                  id="message"
                  name="message"
                  placeholder="Message"
                  className="form-message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
                {/* Button */}
                <button
                  className="contact-button"
                  disabled={isDisabled}
                  onClick={handleSendForm}
                >
                  <span className="text-wrapper">
                    {isLoading ? (
                      <CircularProgress size={25} />
                    ) : (
                      <span className="truncate">Submit</span>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </section>
          {/* Image Section */}
          <section className="image-section">
            <div className="image-section-wrapper">
              {/* First */}
              <div className="image-slider-container">
                {Array.from(contactData)
                  .sort(() => Math.random() - 0.5) // Shuffle the array randomly
                  .map((image, index) => (
                    <div key={index} className="image-wrapper">
                      <img className="image" src={image} alt="" />
                    </div>
                  ))}
              </div>

              {/* Second */}
              <div className="image-slider-container">
                {Array.from(contactData)
                  .sort(() => Math.random() - 0.5) // Shuffle the array randomly
                  .map((image, index) => (
                    <div key={index} className="image-wrapper">
                      <img className="image" src={image} alt="" />
                    </div>
                  ))}
              </div>

              {/* Third */}
              <div className="image-slider-container">
                {Array.from(contactData)
                  .sort(() => Math.random() - 0.5) // Shuffle the array randomly
                  .map((image, index) => (
                    <div key={index} className="image-wrapper">
                      <img className="image" src={image} alt="" />
                    </div>
                  ))}
              </div>

              {/* Forth */}
              <div className="image-slider-container">
                {Array.from(contactData)
                  .sort(() => Math.random() - 0.5) // Shuffle the array randomly
                  .map((image, index) => (
                    <div key={index} className="image-wrapper">
                      <img className="image" src={image} alt="" />
                    </div>
                  ))}
              </div>

              {/* Five */}
              <div className="image-slider-container">
                {Array.from(contactData)
                  .sort(() => Math.random() - 0.5) // Shuffle the array randomly
                  .map((image, index) => (
                    <div key={index} className="image-wrapper">
                      <img className="image" src={image} alt="" />
                    </div>
                  ))}
              </div>

              {/* Six */}
              <div className="image-slider-container">
                {Array.from(contactData)
                  .sort(() => Math.random() - 0.5) // Shuffle the array randomly
                  .map((image, index) => (
                    <div key={index} className="image-wrapper">
                      <img className="image" src={image} alt="" />
                    </div>
                  ))}
              </div>

              {/* Seven */}
              <div className="image-slider-container">
                {Array.from(contactData)
                  .sort(() => Math.random() - 0.5) // Shuffle the array randomly
                  .map((image, index) => (
                    <div key={index} className="image-wrapper">
                      <img className="image" src={image} alt="" />
                    </div>
                  ))}
              </div>

              {/* Eight */}
              <div className="image-slider-container">
                {Array.from(contactData)
                  .sort(() => Math.random() - 0.5) // Shuffle the array randomly
                  .map((image, index) => (
                    <div key={index} className="image-wrapper">
                      <img className="image" src={image} alt="" />
                    </div>
                  ))}
              </div>
            </div>
          </section>
        </div>
      </main>
    </main>
  );

  // TODO: Add loading indicator.
  async function handleSendForm() {
    setIsLoading(true);
    setSuccess(null);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      first_name: firstName,
      last_name: lastName,
      email: email,
      message: message,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://fortysecond-backend-769140167474.asia-northeast1.run.app/api/v1/public/contact",
      requestOptions
    )
      .then((_) => {
        setSuccess("Successfully sent message!");
        setFirstName("");
        setLastName("");
        setEmail("");
        setMessage("");
        setError(null);
        setIsLoading(false);
      })
      .catch((error) => {
        setError("Error: " + error.message);
        setSuccess(null);
        setIsLoading(false);
      });
  }
};

export default Contact;
